<template>
  <div id="app">
    <router-view />
    <vue-snotify />
  </div>
</template>

<script>
import '../node_modules/vue-snotify/styles/material.css'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['notifications'])
  },

  watch: {
    notifications(newVal, oldVal) {
      if (!newVal.length) {
        return
      }

      if (newVal.length >= oldVal.length) {
        const notification = newVal[0]
        this.$snotify[notification.type](notification.message)
        this.notifications.shift()
      }
    }
  }
}
</script>

<style lang="scss" module>
*,
*:before,
*:after {
  box-sizing: border-box;
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: $font-primary;
  font-weight: $weight-regular;
  color: $color-copy;
}

body {
  padding: 0;
  margin: 0;
  background-color: $color-lightBG;
}

a {
  color: $color-primary;
  outline: none;

  &:hover,
  &:focus {
    color: $color-primary-dark;
  }
}

/**
 * Hack required to make "floating labels" pattern work for autofilled inputs
 * See: https://rojas.io/how-to-detect-chrome-autofill-with-vue-js/
 */
:-webkit-autofill {
  animation-name: onAutoFillStart;
}

:not(:-webkit-autofill) {
  animation-name: onAutoFillCancel;
}

@keyframes onAutoFillStart {
  from {
    /**/
  }
  to {
    /**/
  }
}

@keyframes onAutoFillCancel {
  from {
    /**/
  }
  to {
    /**/
  }
}

.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: $color-primary-dark;
    color: $color-light;
    border-radius: $radius-large;
    padding: 8px 10px 10px;
    font-size: $size-x-small;
    font-weight: $weight-medium;
    max-width: 280px;
    text-align: center;
    letter-spacing: 0.1px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: $color-primary-dark;
  }

  &[x-placement^='top'] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='right'] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^='left'] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>
